export function getCsrfToken(state = {}) {
  return state.csrfToken || 'NONE';
}
